import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[DropZone]'
})
export class DropzoneDirective {

  @Output() onFileDropped = new EventEmitter<any>();

  // Listens for drag over event in html
  @HostListener('dragover', ['$event']) public onDragOver(evt: { preventDefault: () => void; stopPropagation: () => void; }): any {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Listens for drag leave event in html
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: { preventDefault: () => void; stopPropagation: () => void; }): any {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Listens for drop event in html
  @HostListener('drop', ['$event']) public ondrop(evt: { preventDefault: () => void; stopPropagation: () => void; dataTransfer: { files: any; }; }): any {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(files);
    }
  }

}